/* =====================================================================
   Accessori step 3 - extra - 26 AGO 2026

   1) conteggio nel titolo dello step  -> "3. Accesorios (1)"
   2) conferma prima di togliere un accessorio PRESELEZIONATO

   Tutto qui dentro e non dentro la sezione: sections/starter-kit.liquid
   e a un passo dal limite di 256 KB imposto da Shopify.
   ===================================================================== */
(function () {
  var radice = document.querySelector('[data-ab-accessori]');
  if (!radice) return;

  var CONTEGGIO = radice.dataset.conteggio === '1';
  var CONFERMA = radice.dataset.conferma === '1';

  var SEL_STEP = '.custom-journey-pack .step.step-3';
  var SEL_ACC = SEL_STEP + ' .flavor';

  function accessori() {
    return Array.prototype.slice.call(document.querySelectorAll(SEL_ACC));
  }

  function scelti() {
    return accessori().filter(function (a) {
      /* Due modi di essere "scelto", ed e voluto che siano due.
         - data-is-accessory-selected: l'ha scelto il cliente, e la riga
           in carrello e il prezzo li gestisce il tema;
         - ab-regali-omaggio: glielo regala il pack, e la riga in
           carrello la mette il sistema dei regali. Questa classe NON
           puo diventare "selected" del tema, se no il prezzo salirebbe
           di un accessorio che invece e gratis.
         Per il conteggio nel titolo pero valgono uguale: il cliente
         quegli accessori ce li ha, e vuole vederli contati. */
      return a.dataset.isAccessorySelected === 'true' ||
             a.classList.contains('ab-regali-omaggio');
    });
  }

  /* ------------------------------------------------------------------
     1) IL CONTEGGIO NEL TITOLO
     ------------------------------------------------------------------ */

  var spanConteggio = null;

  function preparaConteggio() {
    if (!CONTEGGIO) return;
    var titolo = document.querySelector(SEL_STEP + ' h2.step-title');
    if (!titolo) return;
    /* NON un <span>: il tema fa
         document.querySelector('.step-3 h2[data-step-number="3"] span')
       e prende il PRIMO span dentro al titolo per accenderci il pallino
       verde. Con uno span qui dentro il pallino finiva addosso al
       conteggio (che diventava un quadrato verde) e il vero pallino
       dello step non si accendeva piu. Un <i> e invisibile a quel
       selettore. */
    spanConteggio = document.createElement('i');
    spanConteggio.className = 'ab-acc-conteggio';
    spanConteggio.hidden = true;
    /* prima del gruppo "Opcional + pallino", che sta a destra */
    var cerchio = titolo.querySelector('.circle-wrapper');
    if (cerchio) titolo.insertBefore(spanConteggio, cerchio);
    else titolo.appendChild(spanConteggio);
  }

  function aggiornaConteggio() {
    if (!spanConteggio) return;
    var n = scelti().length;
    spanConteggio.textContent = '(' + n + ')';
    spanConteggio.hidden = n === 0;
  }

  /* ------------------------------------------------------------------
     2) LA CONFERMA PRIMA DI TOGLIERE
     ------------------------------------------------------------------ */

  var pannello = null;    /* la scheda con la domanda */
  var modale = null;      /* il velo scuro che la porta al centro */
  var ultimoFocus = null; /* dove torna il fuoco quando si chiude */
  var inCorso = null;      /* il pulsante che il cliente sta togliendo */
  var viaLibera = false;   /* alzato solo quando conferma la rimozione */

  function costruisciPannello() {
    if (!CONFERMA || pannello) return;
    if (!document.querySelector(SEL_STEP)) return;

    pannello = document.createElement('div');
    pannello.className = 'ab-acc-conferma';
    pannello.hidden = true;
    pannello.innerHTML =
      '<div class="ab-acc-conferma__testi">' +
      '<p class="ab-acc-conferma__titolo"></p>' +
      '<p class="ab-acc-conferma__testo"></p>' +
      '</div>' +
      '<div class="ab-acc-conferma__azioni">' +
      '<button type="button" class="ab-acc-conferma__btn ab-acc-conferma__btn--rimuovi"></button>' +
      '<button type="button" class="ab-acc-conferma__btn ab-acc-conferma__btn--tieni"></button>' +
      '</div>';

    pannello.querySelector('.ab-acc-conferma__titolo').textContent = radice.dataset.confermaTitolo || '';
    pannello.querySelector('.ab-acc-conferma__testo').textContent = radice.dataset.confermaTesto || '';
    var bTieni = pannello.querySelector('.ab-acc-conferma__btn--tieni');
    var bVia = pannello.querySelector('.ab-acc-conferma__btn--rimuovi');
    bTieni.textContent = radice.dataset.confermaTieni || '';
    bVia.textContent = radice.dataset.confermaRimuovi || '';

    bTieni.addEventListener('click', chiudiPannello);
    bVia.addEventListener('click', function () {
      var btn = inCorso;
      chiudiPannello();
      if (!btn) return;
      viaLibera = true;
      btn.click();
      viaLibera = false;
    });

    /* 26 AGO 2026 - il pannello adesso vive attaccato al <body>, non
       dentro lo step. Dentro lo step su mobile era inutile: si apriva
       sotto la fila degli accessori, cioe' fuori dallo schermo, la
       pagina non si spostava da sola e il cliente non si accorgeva
       nemmeno che gli era stata fatta una domanda. Attaccato al body
       puo' stare al centro dello schermo sopra a tutto, senza dipendere
       da overflow, altezze e z-index del configuratore.

       Scartata l'alternativa dello scroll automatico: non risolve il
       caso in cui il pannello e' gia' mezzo visibile (nessuno scroll
       parte e il problema resta), litiga con lo scroll del cliente e su
       mobile deve anche schivare la barra fissa di acquisto. */
    modale = document.createElement('div');
    modale.className = 'ab-acc-modale';
    modale.hidden = true;

    var sfondo = document.createElement('div');
    sfondo.className = 'ab-acc-modale__sfondo';

    pannello.hidden = false;   /* da qui in poi comanda il modale */
    pannello.setAttribute('role', 'dialog');
    pannello.setAttribute('aria-modal', 'true');

    modale.appendChild(sfondo);
    modale.appendChild(pannello);
    document.body.appendChild(modale);

    /* Cliccare fuori, o Esc, vale "lo mantengo": e' la risposta che non
       cambia niente. Togliere resta esplicito e a un clic, sul pulsante
       che sta li' accanto: nessuna scorciatoia sleale. */
    sfondo.addEventListener('click', chiudiPannello);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      if (modale && !modale.hidden) chiudiPannello();
    });
  }

  function apriPannello(btn) {
    inCorso = btn;
    if (!modale) return;
    ultimoFocus = document.activeElement;
    modale.hidden = false;
    /* la pagina dietro non deve scorrere mentre si risponde */
    document.documentElement.classList.add('ab-acc-bloccato');
    /* lo aggancia all'accessorio giusto (serve solo a chi legge il DOM) */
    var nome = btn.closest('.flavor');
    pannello.dataset.perAccessorio = nome ? (nome.dataset.name || '') : '';
    var primo = pannello.querySelector('.ab-acc-conferma__btn--tieni');
    if (primo) {
      try { primo.focus({ preventScroll: true }); } catch (e) { primo.focus(); }
    }
  }

  function chiudiPannello() {
    inCorso = null;
    if (modale) modale.hidden = true;
    document.documentElement.classList.remove('ab-acc-bloccato');
    if (ultimoFocus && ultimoFocus.focus) {
      try { ultimoFocus.focus({ preventScroll: true }); } catch (e) {}
    }
    ultimoFocus = null;
  }

  /* Il gestore del tema sta sul pulsante e usa stopPropagation, non
     stopImmediatePropagation: intercettando in fase di cattura sul
     documento arriviamo prima di lui e possiamo fermare il clic. */
  document.addEventListener(
    'click',
    function (e) {
      if (!CONFERMA || viaLibera) return;
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest(SEL_STEP + ' .acc-select');
      if (!btn) return;
      var scheda = btn.closest('.flavor');
      if (!scheda || scheda.dataset.isAccessorySelected !== 'true') return; /* sta aggiungendo: lo lasciamo fare */
      /* si chiede solo per quello che il tema aveva gia scelto per lui:
         sugli altri accessori il clic resta immediato */
      if (scheda.dataset.preselez !== '1') return;
      e.preventDefault();
      e.stopPropagation();
      apriPannello(btn);
    },
    true
  );

  /* ------------------------------------------------------------------ */

  /* ------------------------------------------------------------------
     LO SLIDER SI MISURA A STEP CHIUSO
     Lo step 3 nasce con "display: none" e lo slider viene inizializzato
     subito: misura larghezze pari a zero, conclude che c'e qualcosa da
     scorrere e tiene accesa la barretta grigia per sempre, anche quando
     le due schede ci stanno larghe. Basta chiedergli di rimisurarsi
     quando lo step si apre: a quel punto capisce da solo che non serve
     scorrere, si mette in "lock" e la barra sparisce (la nasconde la
     regola in accessori-extra.css).
     ------------------------------------------------------------------ */
  function rimisuraSlider() {
    var el = document.querySelector('#fum-accessories-step-3');
    if (!el || !el.swiper || typeof el.swiper.update !== 'function') return;
    if (el.offsetParent === null) return;   /* ancora chiuso: inutile */
    try { el.swiper.update(); } catch (e) {}
  }

  var titoloStep = document.querySelector(SEL_STEP + ' h2.step-title');
  if (titoloStep) {
    titoloStep.addEventListener('click', function () {
      /* Aprire o chiudere lo step equivale ad aver risposto "lo tengo":
         il pannello si chiude e l'accessorio resta scelto. Lasciarlo
         aperto sotto uno step chiuso non ha senso, e alla riapertura il
         cliente si ritroverebbe una domanda che non ricorda di aver
         fatto scattare. */
      chiudiPannello();
      setTimeout(rimisuraSlider, 60);
      setTimeout(rimisuraSlider, 400);
    });
  }
  window.addEventListener('resize', function () { setTimeout(rimisuraSlider, 100); });

  preparaConteggio();
  costruisciPannello();
  aggiornaConteggio();
  setTimeout(rimisuraSlider, 300);

  /* il conteggio segue ogni cambio di stato, compresi quelli fatti dal
     tema (preselezione, ripristini): si guarda il risultato, non chi
     l'ha causato */
  document.addEventListener('click', function () { setTimeout(aggiornaConteggio, 30); }, true);
  var osservatore = new MutationObserver(function () { aggiornaConteggio(); });
  accessori().forEach(function (a) {
    /* si guarda anche "class": e li che compare ab-regali-omaggio quando
       il pack sale e un accessorio diventa un regalo */
    osservatore.observe(a, {
      attributes: true,
      attributeFilter: ['data-is-accessory-selected', 'class']
    });
  });
})();

/* =====================================================================
   The Bond vuole due accessori, non uno - 30 AGO 2026

   IL BUCO CHE PERDEVA SOLDI
   The Bond non e' un inalatore, sono due. La Resistencia PRO sta DENTRO
   l'inalatore, quindi con The Bond ne servono due - ma il tema ne
   metteva in carrello sempre e solo una, a 9,99, per tutti e due. Chi
   comprava The Bond col PRO si portava a casa la seconda resistenza
   gratis. Non era un caso limite: il PRO e' preselezionato, quindi
   capitava a ogni ordine con The Bond in cui il cliente non lo toglieva.

   COSA FA ADESSO
   Quando il dispositivo scelto e' quello doppio, gli accessori elencati
   nell'editor valgono due: due in carrello, prezzo doppio nel totale, e
   prezzo doppio scritto sul pulsante. Le tre cose vanno insieme o non
   vanno per niente: se il carrello raddoppia e il pulsante no, il
   cliente scopre il prezzo vero al checkout, che e' peggio del buco.

   PERCHE' QUANTITA' DUE E NON PREZZO DOPPIO
   Su Shopify il prezzo lo decide la variante, il tema puo' solo dire
   quale e quante. Ma e' anche la scelta giusta di suo: in magazzino
   partono davvero due pezzi, e sull'ordine si legge "2" invece di un
   numero strano da interpretare.

   PERCHE' IL RICONOSCIMENTO E' PER ID E NON PER NOME
   "The Bond" e' un titolo: si traduce e si rinnomina. L'ID della
   variante no. (L'incisione personalizzata riconosce ancora The Bond dal
   nome: oggi funziona perche' quel nome non e' tradotto su nessuno dei
   quattro mercati, ma e' un punto fragile da sistemare quando si
   ripassa di li.)

   QUELLO CHE NON TOCCA
   Gli accessori REGALATI dalla scala dei premi non passano di qui: non
   hanno la classe "selected" del tema e la loro riga la mette
   ab-regali.js. Un regalo resta uno, anche con The Bond.
   ===================================================================== */
(function () {
  var radice = document.querySelector('[data-ab-accessori]');
  if (!radice) return;

  var PRODOTTI_DOPPI = (radice.dataset.doppiProdotti || '')
    .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  var VARIANTE_DOPPIA = (radice.dataset.doppiaVariante || '').trim();
  var NOTA = radice.dataset.doppioNota || '';

  if (!PRODOTTI_DOPPI.length || !VARIANTE_DOPPIA) return;

  var SEL_STEP_3 = '.custom-journey-pack .step.step-3';

  function dispositivoDoppio() {
    var b = document.querySelector('.custom-journey-pack .step-1 .fum-journeypdp-step-item button.select-button.selected');
    var v = b ? b.closest('.variant') : null;
    return !!v && String(v.dataset.variantId || '').trim() === VARIANTE_DOPPIA;
  }

  /* Quante ne servono di QUESTO accessorio. La chiamano la sezione (per
     la riga in carrello e per il totale) e prezzo-testata.js (per il
     prezzo sul pulsante): un solo posto decide, e le tre cose non
     possono piu' scollegarsi. */
  function quante(scheda) {
    if (!scheda || !scheda.dataset) return 1;
    if (PRODOTTI_DOPPI.indexOf(String(scheda.dataset.productId || '').trim()) < 0) return 1;
    return dispositivoDoppio() ? 2 : 1;
  }

  window.abAccessori = window.abAccessori || {};
  window.abAccessori.quante = quante;

  /* ------------------------------------------------------------------
     IL PULSANTE DEVE DIRE IL PREZZO VERO
     Da NON scelto il tema scrive "+9,99". Con The Bond quel numero e'
     falso: il cliente clicca aspettandosi 9,99 e ne paga 19,98.
     Da scelto ci pensa prezzo-testata.js, che moltiplica con la stessa
     funzione qui sopra.

     Si riscrive solo se il testo e' diverso da quello giusto: senza
     questa guardia l'osservatore qui sotto si sveglierebbe da solo, a
     ripetizione.
     ------------------------------------------------------------------ */
  function valuta() {
    var m = (document.querySelector(SEL_STEP_3 + ' .acc-select span') || {}).textContent || '';
    var s = m.replace(/[\d.,\s+]/g, '').replace(/[A-Za-zÀ-ÿ•·]/g, '');
    return s || '€';
  }

  function comeIlTema(n) {
    return n.toFixed(2).replace('.', ',');
  }

  function scriviEtichette() {
    var schede = document.querySelectorAll(SEL_STEP_3 + ' .flavor');
    var simbolo = valuta();

    for (var i = 0; i < schede.length; i++) {
      var scheda = schede[i];
      var n = quante(scheda);
      var bottone = scheda.querySelector('.acc-select');
      var etichetta = bottone ? bottone.querySelector('span') : null;
      if (!etichetta) continue;

      scheda.classList.toggle('ab-acc-doppio', n > 1);

      /* Il cartellino va accanto al NOME, sulla stessa riga. Perche'
         proprio li' - e perche' deve restare corto - sta scritto in
         accessori-extra.css: in breve, il nome e' corto e sulla sua riga
         avanzano fra i 78 e gli 85 pixel su tutti e quattro i mercati,
         mentre "x2" ne occupa 23. Un testo piu' lungo di cinque o sei
         caratteri torna a capo, e con lui torna la riga in piu' che
         disallineava la scheda dalle altre. */
      var nota = scheda.querySelector('.ab-acc-doppio__nota');
      if (n > 1 && NOTA) {
        if (!nota) {
          var titolo = scheda.querySelector('.variant_title');
          if (titolo) {
            nota = document.createElement('span');
            nota.className = 'ab-acc-doppio__nota';
            nota.textContent = NOTA;
            titolo.appendChild(nota);
          }
        }
      } else if (nota) {
        nota.parentNode.removeChild(nota);
      }

      /* 31 AGO 2026 - un accessorio REGALATO (Kit di pulizia e Toppers al
         10-PACK) qui dentro risulta "non scelto", perche' ab-regali.js lo
         toglie di proposito dalla selezione a pagamento. Senza questa
         riga gli riscrivevamo sopra "+6,99" e "+9,99": il cliente vedeva
         un prezzo proprio sulla cosa che gli stiamo regalando. La sua
         etichetta la scrive ab-regali.js, e non si tocca. */
      if (scheda.classList.contains('ab-regali-omaggio')) continue;

      /* il prezzo da NON scelto: "+9,99" -> "+19,98" */
      if (scheda.dataset.isAccessorySelected === 'true') continue;
      var prezzo = Number(scheda.dataset.price) || 0;
      if (!prezzo) continue;
      var voluto = '+' + simbolo + comeIlTema(prezzo * n);
      if (etichetta.textContent.trim() !== voluto) etichetta.textContent = voluto;
    }
  }

  /* Il tema riscrive l'etichetta al clic e il dispositivo si cambia col
     clic: un solo ascoltatore in cattura copre tutti e due, con un
     respiro per lasciar finire il tema. */
  document.addEventListener('click', function () {
    setTimeout(scriviEtichette, 60);
    setTimeout(scriviEtichette, 250);
  }, true);

  if (window.MutationObserver) {
    var zona = document.querySelector(SEL_STEP_3);
    if (zona) {
      new MutationObserver(function () { scriviEtichette(); }).observe(zona, {
        subtree: true,
        childList: true,
        characterData: true
      });
    }
  }

  scriviEtichette();
  window.addEventListener('load', scriviEtichette);
})();
